import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import StockServices from '@root/modules/Sellers/Stock/services/stock';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Card, DatePicker, Menu, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import DropdownButton from '../../Inquiry/components/DropdownButton';
import SearchBox from '../../Inquiry/components/Search';
import BreadcrumbList from '../components/Breadcrumb';

interface DataType {
  key: React.Key;
  no: number;
  name: string;
  detailAddress: string;
  country: number;
  updated_at: Date;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const Stock = () => {
  const [t] = useTranslate();
  const [list, setList] = useState([] as any);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [listExcel, setListExcel] = useState([] as any);
  const [totalPages, setTotalPages] = useState(2);
  const [totalItem, setTotaItem] = useState();
  const [loading, setLoading] = useState(false);
  const [save, setSave] = useState([] as any);
  const [currentPage, setCurrentPage] = useState(1);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sort, setSort] = useState(true);
  const history = useHistory();

  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';

  const Breadcrumb = [
    {
      tittle: '재고 관리',
      url: ''
    },
    {
      tittle: '물류센터 조회',
      url: ''
    }
  ];

  const columns: ColumnsType<DataType> = [
    {
      title: 'No',
      dataIndex: 'key'
    },
    {
      title: t('table:seller:logistic-center'),
      dataIndex: 'name'
    },
    {
      title: t('table:seller:address'),
      dataIndex: 'detailAddress'
    },
    {
      title: '국가',
      dataIndex: 'country'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {t('table:seller:update')}
          {!!sort ? (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
              }}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
      // key: "updated_at",
    }
  ];

  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };
  const onChangeState = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };

  const listLabel = [
    {
      id: 1,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={[
            {
              label: '물류센터명',
              key: 'name'
            },
            {
              type: 'divider'
            },
            {
              label: '국가',
              key: 'country'
            }
          ]}
        />
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeyss: React.Key[], selectedRows: DataType[]) => {
      setListExcel(selectedRows);
      setSelectedRowKeys(selectedRowKeyss);
      if (
        save.length > 0 &&
        save.some((item: any) => item.page == currentPage)
      ) {
        let a = save.findIndex((item: any) => item.page == currentPage);
        save[a] = { page: currentPage, select: selectedRowKeyss };
      } else {
        setSave((item: any) => [
          ...item,
          ...[{ page: currentPage, select: selectedRowKeyss }]
        ]);
      }
    },
    getCheckboxProps: (record: DataType) => ({
      name: record.name
    })
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY.MM.DD';
  const idExport = save.reduce(
    (s: number[], x: any) => [...s, ...x.select],
    []
  );

  const handelExportExcel = async (
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string
  ) => {
    if (listExcel.length > 0) {
      let selected = save.reduce(
        (s: number[], x: any) => [...s, ...x.select],
        []
      );
      const responseById = await StockServices.exportExcelById(selected);
      const outputFilename = `Warehouse${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await StockServices.exportExcel({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt
      });
      const outputFilename = `Warehouse${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const getPagination = async (
    page: number,
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string
  ) => {
    setLoading(true);
    const temp = await StockServices.getPaging({
      productName,
      page,
      fieldSearch,
      sort,
      fromDt,
      toDt
    });
    let list = temp?.data.map((item: any, index: number) => {
      return {
        ...item,
        updated_at: formatDateTime(item.updated_at),
        // updated_at: moment(item.updated_at)
        //   .utc(true ?? 9)
        //   .format('YYYY.MM.DD hh:mm:ss A'),
        no: index + 1 + (currentPage - 1) * 10,
        key: item.id
      };
    });
    setList(list);
    setTotalPages(temp.meta.totalPages);
    setCurrentPage(temp.meta.currentPage);
    setTotaItem(temp.meta.totalItems);
    setLoading(false);
  };

  useEffect(() => {
    getPagination(1, proName, valueSearch, sort, fromDt, toDt);
  }, [debounc, proName, sort, fromDt, toDt]);

  useEffect(() => {
    let selected = save.reduce((s: number[], x: any) => {
      return x.page == currentPage ? [...s, ...x.select] : s;
    }, []);
    if (selected.length > 0) {
      setSelectedRowKeys(selected);
    }
  }, [currentPage]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                getDate(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  label={labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>총 물류센터 {totalItem}</span>
                  <span className="table__head --right">
                    선택 물류센터
                    {idExport.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    onClick={() => {
                      handelExportExcel(
                        valueSearch,
                        proName,
                        sort,
                        fromDt,
                        toDt
                      );
                    }}
                  >
                    {t('common:download')}
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                rowSelection={rowSelection}
                pagination={{
                  total: totalPages * 10,
                  onChange: (page, limit) => {
                    getPagination(
                      page,
                      valueSearch,
                      proName,
                      sort,
                      fromDt,
                      toDt
                    );
                  }
                }}
                // onRow={() => ()}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/seller/stock/${item.key}`);
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Stock;
